<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.75"
      y="1.75"
      width="20.5"
      height="20.5"
      rx="5.25"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <g clip-path="url(#clip0_51_50179)">
      <path
        d="M16.3568 8.40522C15.6774 7.98378 15.1872 7.30925 15.0342 6.52342C15.0012 6.35368 14.9828 6.17882 14.9828 6H12.8144L12.8107 14.2678C12.7745 15.1938 11.9734 15.9368 10.9915 15.9368C10.6863 15.9368 10.399 15.8644 10.1459 15.7375C9.56565 15.4472 9.16843 14.8686 9.16843 14.2029C9.16843 13.2466 9.98636 12.4685 10.9913 12.4685C11.179 12.4685 11.3589 12.498 11.529 12.5486V10.4425C11.3528 10.4195 11.1739 10.4055 10.9913 10.4055C8.79054 10.4055 7 12.1087 7 14.2029C7 15.4874 7.67451 16.6244 8.70415 17.3117C9.35223 17.745 10.141 18 10.9915 18C13.1925 18 14.9828 16.2966 14.9828 14.2029V10.0102C15.8333 10.5909 16.8754 10.9331 18 10.9331V8.86996C17.3943 8.86996 16.8301 8.69882 16.3568 8.40522Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_51_50179">
        <rect width="11" height="12" fill="white" transform="translate(7 6)" />
      </clipPath>
    </defs>
  </svg>
</template>
